import { DropiState, Order } from "../../SalesPage/SalesPageInterface";
import { ProductInterface } from "../OrderDetailsInterface";
import {
  getOrderDisplayCurrencyCode,
  getOrderDisplayTotalWithDiscount,
} from "../../../utils/orderDisplayTotals";
import { formatCurrency, getCurrencySymbol } from "../../../utils/formatters";

// Misma matemática que usaba PaymentDetailsCard: el total mostrado es la suma
// de productos con descuento más las ofertas adicionales; si no hay productos
// cae al total de la orden. Centralizado para que la tabla de productos y el
// panel de pago nunca diverjan.
export const getOrderTotals = (order: Order, products: ProductInterface[]) => {
  const benefitTotal =
    order.benefit_purchases?.reduce((sum, benefit) => sum + (benefit.price || 0), 0) ?? 0;
  const productsSubtotal =
    products.length > 0
      ? products.reduce((sum, product) => sum + product.total_value_with_discount, 0)
      : getOrderDisplayTotalWithDiscount(order);
  const total = products.length > 0 ? productsSubtotal + benefitTotal : getOrderDisplayTotalWithDiscount(order);

  const currencyCode = getOrderDisplayCurrencyCode(order);
  const currencySymbol = getCurrencySymbol(currencyCode);
  const formatAmount = (amount: number) => formatCurrency(amount, currencySymbol);

  return { benefitTotal, productsSubtotal, total, currencyCode, currencySymbol, formatAmount };
};

// La página lo usa para decidir el layout: con integraciones las alturas son
// naturales (expandir una fila no debe redimensionar la card de productos);
// sin integraciones, productos estira para emparejar con el panel.
export const hasOrderIntegrations = (order: Order) =>
  order.order_state !== "draft" &&
  order.state !== "draft" &&
  (order.dropi_state === DropiState.SUCCESS ||
    order.dropi_state === DropiState.ERROR ||
    order.dropi_state === DropiState.PENDING_SYNC ||
    Boolean(order.shopify_integration_state) ||
    Boolean(order.mastershop_state) ||
    Boolean(order.mastershop_integration_error));

// Los errores de integración llegan como "CODIGO_EN_MAYUSCULAS: mensaje
// humano". El código va al detalle técnico; al usuario se le muestra solo
// el mensaje.
export const splitIntegrationError = (raw?: string | null) => {
  if (!raw) return { message: undefined, code: undefined };
  const match = raw.match(/^([A-Z][A-Z0-9_]{2,})\s*:\s*([\s\S]+)$/);
  if (match) return { code: match[1], message: match[2].trim() };
  return { message: raw, code: undefined };
};
